<template>
    <div class="transactions-component">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12 mt-3">
                    <div class="card shadow-sm p-4">
                        <h4 class="text-center mb-3">Транзакции <span class="btn btn-sm btn-primary float-right" data-target="#transactionsModal" data-toggle="modal">Добавить</span></h4>


                        <vuetable ref="vuetable" api-url="/admin/api/transactions" :fields="fields" @vuetable:pagination-data="onPaginationData"
                                  data-path="data" pagination-path="meta" :show-sort-icons="true" :css="css.table" :append-params="additionalQueryParams"
                                  :sort-params="getSortParam"
                        >

                            <div slot="link"  slot-scope="{rowData}">
                                <a target="_blank" :href="`/user/${rowData.user.id}/profile`">
                                    {{rowData.user.name}}
                                </a>
                            </div>

                            <div slot="target"  slot-scope="{rowData}">
                                <a target="_blank" :href="`/pets/${rowData.pet.id}`" v-if="rowData.pet">
                                    {{rowData.pet.name}}
                                </a>
                                <a target="_blank" :href="`/projects/${rowData.project.id}`" v-else-if="rowData.project">
                                    {{rowData.project.name}}
                                </a>
                            </div>


                        </vuetable>



                        <!-- Modal -->
                        <div class="modal fade" id="transactionsModal" tabindex="-1" role="dialog" aria-labelledby="transactionsModal" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Добавить транзакцию</h5>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        <div class="col-sm-12 mt-3">
                                            <p class="mb-1">От кого:</p>
                                            <div class="search">
                                                <input class="form-control" type="search" v-model="search.from.input" placeholder="Поиск. Начните вводить буквы">
                                                <div class="field-error-text" v-if="$v.form.from.user.$error">- Необходимо указать от кого транзакция</div>
                                                <div class="search-results" v-if="search.from.input">
                                                    <div class="object-type">Пользователи</div>
                                                    <div class="search-items">
                                                        <div class="search-item" v-for="object in search.from.results.users" @click="selectMoveFundsTarget('from', 'user', object)">
                                                            <img :src="'/storage' + object.avatar.path" alt="" v-if="object.avatar">
                                                            <div>
                                                                <div class="search-item-name">{{ object.name }}</div>
                                                                <div class="search-item-desc">{{object.type === 'USER_TYPE_VOLUNTEER' || object.type === 'USER_TYPE_ANONYMOUS' ? 'Пользователь' : (object.type === 'USER_TYPE_ORGANIZATION' ? 'Организация' : '') }}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row mt-3" v-if="form.from.user">
                                                <div class="col-12">
                                                    <p class="mb-0">Вы выбрали:</p>
                                                    <div class="search-item selected">
                                                        <span class="search-item-remove lnr lnr-cross-circle" @click="deleteSelectedSearchItem('from')">&times;</span>
                                                        <img :src="'/storage' + form.from.user.avatarUrl.path" v-if="form.from.user.avatarUrl">
                                                        <div>
                                                            <div class="search-item-name">{{ form.from.user.name }}</div>
                                                            <div class="search-item-desc">{{form.from.user.type === 'USER_TYPE_VOLUNTEER' || form.from.user.type === 'USER_TYPE_ANONYMOUS' ? 'Пользователь' : (form.from.user.type === 'USER_TYPE_ORGANIZATION' ? 'Организация' : '') }}</div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 mt-3">
                                            <p class="mb-1">Кому:</p>
                                            <div class="search">
                                                <input class="form-control" type="search" v-model="search.to.input" placeholder="Поиск. Начните вводить буквы">
                                                <div class="field-error-text" v-if="$v.form.to.target.$error">- Необходимо указать кто получатель средств</div>
                                                <div class="search-results" v-if="search.to.input">
                                                    <template v-for="type in ['petsWithNeedSum', 'pets', 'projects']">
                                                        <template v-if="search.to.results[type].length">
                                                            <div class="object-type">
                                                                {{ type === 'petsWithNeedSum' ? 'Нуждаются в помощи' : (type === 'pet' ? 'Ищут друга' : 'Проекты') }}
                                                            </div>
                                                            <div class="search-items">
                                                                <div class="search-item" v-for="object in search.to.results[type]" @click="selectMoveFundsTarget('to', type, object)">
                                                                    <img :src="'/storage/' + object.avatar.path" alt="" v-if="object.avatar">
                                                                    <div>
                                                                        <div class="search-item-name">{{ object.name }}</div>
                                                                        <div class="search-item-desc">{{ object.ad_title }}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </template>
                                                </div>
                                            </div>

                                            <div class="row mt-3" v-if="form.to.target">
                                                <div class="col-12">
                                                    <p class="mb-0">Вы выбрали:</p>
                                                    <div class="search-item selected">
                                                        <span class="search-item-remove lnr lnr-cross-circle" @click="deleteSelectedSearchItem('to')">&times;</span>
                                                        <img :src="'/storage/' + form.to.target.avatarUrl" alt="" v-if="form.to.target.avatarUrl">
                                                        <div>
                                                            <div class="search-item-name">{{ form.to.target.name }}</div>
                                                            <div class="search-item-desc">{{ form.to.target.ad_title }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 mt-3">
                                            <div class="form-group">
                                                <label>Сумма:</label>
                                                <input type="number" min="0" class="form-control" v-model.number="form.amount">
                                                <div class="field-error-text" v-if="$v.form.amount.$error">- Необходимо указать сумму транзакции</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Отменить</button>
                                        <button type="button" class="btn btn-primary" @click="sendForm">Добавить</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="pagination-area mt-3 mb-3">
                        <vuetable-pagination :css="css.pagination" ref="pagination" @vuetable-pagination:change-page="onChangePage"/>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Vuetable from 'vuetable-2';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';

import {required, decimal, minValue, requiredIf} from 'vuelidate/lib/validators';

const initialSearch = {
    from: {
        input: '',
        results: {
            users: []
        }
    },
    to: {
        input: '',
        results: {
            pets: [],
            projects: [],
            petsWithNeedSum: []
        },
    }
};

const initialSendForm = {
    from: {
        user: null,
    },
    to: {
        target: null,
        type: null
    },
    amount: 0
};

export default {
    name: "AccountantTransactions",
    components: { Vuetable, VuetablePagination },
    data() {
        return {

            fields: [

                { name: 'id', title: 'ID', titleClass: 'text-left', sortField: 'id' },

                { name: 'link', title: 'От кого', titleClass: 'text-left' },

                { name: 'target', title: 'Кому', titleClass: 'text-left' },

                { name: 'debit', title: 'Дебит', titleClass: 'text-left', sortField: 'debit',
                    formatter: value => {
                        return value ? `${value} BYN` : '';
                    }
                },

                { name: 'credit', title: 'Кредит', titleClass: 'text-left', sortField: 'credit',
                    formatter: value => {
                        return value ? `${value} BYN` : '';
                    }
                },

            ],

            css:{

                table: {
                    ascendingIcon: 'icn asc-icn',
                    descendingIcon: 'icn desc-icn',
                    sortableIcon: 'icn sortable-icn',
                },

                pagination:{
                    wrapperClass: 'pagination',
                    linkClass: 'page-numbers',
                    icons: {
                        first: 'first',
                        prev: 'prv',
                        next: 'nxt',
                        last: 'last',
                    },
                },

            },

            additionalParams: {
                per_page: 5,
                order_by: null,
                direction: null,
            },

            search: {
                from: {
                    input: '',
                    results: {
                        users: []
                    }
                },
                to: {
                    input: '',
                    results: {
                        pets: [],
                        projects: [],
                        petsWithNeedSum: []
                    },
                }
            },
            form: {
                from: {
                    user: null,
                },
                to: {
                    target: null,
                    type: null
                },
                amount: 0
            },
        }
    },
    mounted() {
        let self = this;

        $('#transactionsModal').on('hidden.bs.modal', function (e) {
            self.resetModalValues();
        })

    },

    computed: {
        additionalQueryParams() {

            let params = this.additionalParams;

            return params;

        },
    },

    watch: {
        additionalQueryParams(){
            this.$refs.vuetable.refresh();
        },
        'search.from.input': function () {
            this.getSearchResults('from');
        },
        'search.to.input': function () {
            this.getSearchResults('to');
        }
    },

    methods: {

        getSortParam(sortOrder) {

            if(sortOrder.length) {

                if( this.additionalParams.direction  ===  'desc' && sortOrder[0].direction !== 'desc' &&  this.additionalParams.order_by  ===  sortOrder[0].sortField ){
                    this.$refs.vuetable.sortOrder.splice(0,1)

                    this.additionalParams.order_by = null;
                    this.additionalParams.direction = null;
                    return
                }

                this.additionalParams.order_by = sortOrder[0].sortField;
                this.additionalParams.direction = sortOrder[0].direction;

            }

        },

        onPaginationData(paginationData) {
            const lastPage = paginationData.last_page,
                currentPage = paginationData.current_page;

            if( +currentPage > +lastPage  ){
                return this.$refs.vuetable.gotoPage(+lastPage);
            }

            this.$refs.pagination.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page)
        },

        resetModalValues(){

            this.search = {...initialSearch };
            this.form = {...initialSendForm };

            this.$v.form.$reset();

        },

       async sendForm(){
            let self = this;

            this.$v.form.$touch();

            if (this.$v.form.$invalid) {
                return false;
            }

            let formData = {
                'user_id': this.form.from.user.id,
                'pet_id': this.form.to.target.type === 'pet' ? this.form.to.target.id : null,
                'project_id': this.form.to.target.type === 'project' ? this.form.to.target.id : null,
                'credit': this.form.amount
            };

            try {

                const { data: { success = false, ...rest } } =  await axios.post( '/admin/api/transactions', formData );

                if( success ){
                    $('#transactionsModal').modal('hide');
                    this.resetModalValues();
                    this.$refs.vuetable.reload();
                }


            } catch ( _e ){

                console.log( _e );

            }

        },
        deleteSelectedSearchItem(direction) {
            if (direction === 'from') {
                this.form.from.user = null;
            } else {
                this.form.to.target = null;
            }
        },
        selectMoveFundsTarget(direction, type, object) {

            if (type === 'user') {

                this.search.from = {...initialSearch.from}
                this.form.from.user = object;

            } else {

                this.search.to = {...initialSearch.to}
                this.form.to.target = object;
                this.form.to.type = type;

            }
        },

        async getSearchResults(direction) {
            let self = this;
            let url = '/api/catalog/search';

            if (direction === 'from') {
                url = '/api/users/search';
            }

            if (!self.search[direction].input) return false;

            try {

                const { data:
                    {
                        success = false,
                        data = {
                            users: [],
                            pets: [],
                            projects: [],
                            petsWithNeedSum: []
                        },
                        ...rest
                    }
                } = await axios.get ( url, { params: { keyword: self.search[direction].input } } );

                if( success ){
                    if (direction === 'from') {
                        self.search.from.results.users = data.users;
                    } else {
                        self.search[direction].results.pets = data.pets;
                        self.search[direction].results.projects = data.projects;
                        self.search[direction].results.petsWithNeedSum = data.petsWithNeedSum;
                    }
                }

            } catch ( _e ){

                console.log( _e )

            }

        },

    },



    validations: {
        form: {
            from: {
                user: {
                    required
                }
            },
            to: {
                target: {
                    required
                },
                type: {
                    required
                }
            },
            amount: {
                required,
                decimal,
                minValue: minValue(0.01)
            }
        },
    },


}
</script>

<style lang="scss" scoped>

.sortable{

    position: relative;

    .sortable-icn{
        content: '↕';
        display: inline-block;
        position: relative;
        font-size: 16px;
    }

}

.pagination-area::v-deep a {
    line-height: 36px;
    display: inline-block;
    min-width: 48px;
    -webkit-transition: 0.3s ease;
    -o-transition: 0.3s ease;
    transition: 0.3s ease;
    background: #fff;
    -webkit-border-radius: 25px;
    margin: 0 2px;
    border-radius: 25px;
    font-weight: 500;
    color: #747b86;
    text-align: center;
    overflow: hidden;
    height: 36px;
    cursor: pointer;
    outline: none;
    outline-offset: 0;

    i{
        display: block;
        position: relative;
        width: 100%;
        height: 100%;
    }

    .first{
        &::before{
            content: '<<';
        }
    }

    .prv{
        &::before{
            content: '<';
        }
    }

    .nxt{
        &::before{
            content: '>';
        }
    }


    .last{

        &:before{
            content: '>>';
        }
    }

    &.active,
    &:hover{

        background: #2e76e4;
        color: #fff;

    }

    &.disabled{
        pointer-events: none;
        cursor: auto;

        &:hover{
            background: #fff;
            color: #747b86;
        }

    }



}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}
</style>

<style lang="scss">


.preview-doc {
    width: 50px;
    margin-right: 5px;
}

.paginator ul {
    list-style: none;
    padding: inherit;
    margin: 0 auto;
    display: inline-block;

    li {
        padding: 2px 10px;
        background-color: #527bff;
        float: left;
        margin-right: 10px;
        border-radius: 50%;
        color: #fff;

    }
}

.cursor-pointer {
    cursor: pointer;
}

.nowrap,
.actions {
    white-space: nowrap;
}


.search {
    position: relative;
    text-align: left;

    .search-results {
        position: absolute;
        z-index: 2;
        background: #fff;
        box-shadow: 0 6px 6px 0 #d8d8d8;
        width: 100%;
        padding: 10px;
        max-height: 350px;
        overflow: auto;

        .object-type {
            text-align: center;
            font-weight: bold;
            margin-bottom: 5px;
        }

        .search-items {


        }
    }


}


.search-item.selected {
    background: #f6f6f6;
}

.search-item {
    padding: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    position: relative;

    &:hover {
        background: #f6f6f6;
    }

    .search-item-remove {
        font-size: 16px;
        position: absolute;
        right: -10px;
        top: -10px;
        width: 20px;
        height: 20px;
        cursor: pointer;
        color: #6b6e70;
        background: white;
        font-weight: bold;
        z-index: 1000;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 0 6px 0 #ccc;
    }

    img {
        margin-right: 10px;
        width: 50px;
        min-width: 50px;
        border-radius: 15px;
    }

    .search-item-name {
        font-weight: bold;
    }

    .search-item-desc {
        font-size: 10px;
        color: #0674ec;
    }

}

.field-error-text {
    color: red;
    font-size: 0.7rem;
    margin-top: 10px;
}


</style>
